import { useDeleteDrawing, useDrawings, useDuplicateDrawing } from "hooks/api/drawings/drawings.hook"
import { useMessage } from "hooks/message.hook"
import { useProcessFiles } from "hooks/api/processFiles/processFiles.hook"
import { useDeleteConfirmModalStore } from "store/modal.store"
import { useFillesTableStore } from "store/table.store"
import { useSearchParams } from "react-router-dom"
import { AxiosError } from "axios"
import type { TStopPropagation } from "types/default.type"
import type { TTable } from "types/table.type"
import type { TableProps } from "antd/es/table"

const version = import.meta.env.VITE_APP_VERSION

export const TableAllFilesHandlers = () => {
	const { refetch: refetchDrawings } = useDrawings()
	const { mutate: processFilesMutate, isPending: isProcessigPending } = useProcessFiles()
	const { mutate: duplicateDrawingMutate } = useDuplicateDrawing()
	const { error: userErrorMessage, success: userSuccessMessage } = useMessage()
	const { mutate: deleteDrawing } = useDeleteDrawing()
	const [, setSearchParams] = useSearchParams()

	const { setDeleteConfirmModalClose, deleteFile } = useDeleteConfirmModalStore()
	const { setCurrentPage, setDuplicatingIds, removeDuplicatingId } = useFillesTableStore()

	// Start processing handle
	const startProcessingHandle = (id: number, e?: TStopPropagation) => {
		if (e) e.stopPropagation()
		processFilesMutate({ id, version })
	}

	// Handle row click for opening the drawer
	const onRowHandle = (record: TTable) => ({
		onClick: () => {
			const recordId = record.id.toString()
			const status = record.status.status.toString()
			document.title = record.name // Set document title as file name
			setSearchParams({ drawingID: recordId, status: status })
		},
		onMouseEnter: () => {
			document.body.style.cursor = "pointer"
		},
		onMouseLeave: () => {
			document.body.style.cursor = "default"
		},
	})

	// Delete the file on delete confirmation
	const deleteFileHandle = () => {
		deleteDrawing(deleteFile.id, {
			onSuccess: () => {
				if (refetchDrawings) {
					refetchDrawings()
					userSuccessMessage(`${deleteFile.fileName} is succesfully deleted`)
					setDeleteConfirmModalClose()
				}
			},
			onError: () => {
				userErrorMessage("Something went wrong, please try again later")
				setDeleteConfirmModalClose()
			},
		})
	}

	const duplicateDrawingHandle = (id: number) => {
		setDuplicatingIds(id)
		duplicateDrawingMutate(id, {
			onSuccess: () => {
				if (refetchDrawings) {
					refetchDrawings()
				}
				userSuccessMessage("File duplicated successfully")
				removeDuplicatingId(id)
			},
			onError: (error) => {
				if (error instanceof AxiosError) {
					userErrorMessage("Something went wrong, please try again later")
				}
				removeDuplicatingId(id)
			},
		})
	}

	const onChangeTableHandle: TableProps<TTable>["onChange"] = (pagination, _filters, _sorter, extra) => {
		const currentPage = pagination.current!
		const onChangeAction = extra.action

		if (onChangeAction === "paginate") {
			setCurrentPage(currentPage)
		}
	}

	return {
		startProcessingHandle,
		onRowHandle,
		deleteFileHandle,
		onChangeTableHandle,
		duplicateDrawingHandle,
		isProcessigPending,
	}
}
